// ===============================
// SERVICES AUDIT APPROACH DATA
// ===============================

export const auditApproachHeading = {
  subtitle: "OUR AUDIT APPROACH",
  title: "A 4-STEP AUDIT METHODOLOGY FOR CLEAR INSIGHTS",
  description1:
    "We apply a structured, technology-enabled methodology to ensure our audits are efficient, insightful, and compliant with the highest professional standards.",
  description2:
    "We apply a structured, technology-enabled methodology to ensure our audits are efficient, insightful, and compliant with the highest professional standards.",
};

export const auditApproachSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Planning & Risk Assessment",
    text: "We understand your business, industry, and control environment to design a risk-based audit plan.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Testing & Evaluation",
    text: "Detailed examination of financial data, transactions, and internal controls using analytical and substantive testing.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Review & Analysis",
    text: "Comprehensive review of findings and financial statements to ensure accuracy and compliance.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Reporting & Recommendations",
    text: "Deliver clear, value-added insights to improve governance, efficiency, and financial reporting processes.",
  },
];
export const fsaHeading = {
  subtitle: "HOW WE WORK",
  title: "A 4-STEP STRUCTURED AUDIT FRAMEWORK FOR CLEAR INSIGHTS",
  description1:
    "A strong audit begins with understanding why financial discrepancies occur, not just where they show up. Using sector-specific benchmarks, we deliver an audit that goes beyond tick box checks and gives decision-makers clarity on performance, compliance, and financial resilience.",
  description2:
    "Each audit cycle is highly collaborative, backed by transparent communication and timely insights, ensuring your organization is compliant and strategically positioned for sustained growth.",
};

export const fsaSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Planning & Risk Mapping",
    text: "We identify high-risk areas using trend analysis, materiality thresholds, and industry benchmarks to pinpoint where financial exposure is most likely.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Process Testing",
    text: "We validate controls through sample testing, walkthroughs, and system audits so that processes operate as usual under real-world conditions.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Data Analysis",
    text: "We apply analytical tools and ratio-based diagnostics to detect inconsistencies and patterns that reveal operational or reporting gaps.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Clear Reporting",
    text: "We deliver concise, investor-ready reports outlining key findings, financial impacts, and short and long-term practical improvement actions.",
  },
];
export const ifrsHeading = {
  subtitle: "OUR METHODOLOGY",
  title: "A CLEAR, PRACTICAL & BUSINESS-FIRST IFRS APPROACH",
  description1:
    "Every IFRS standard affects more than accounting – it influences margins, investor confidence, agreements, valuations, and how leadership tells the business story. We begin by mapping each standard to your real business drivers and internal processes.",
  description2:
    "Our team works closely with your finance, operations, and leadership units to translate complex standards into clean disclosures, stronger controls, and smoother audits. Hence, you gain sharper visibility into performance and decision-making across the organization.",
};

export const ifrsSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Impact Mapping",
    text: "We analyze how each IFRS standard touches your revenue model, costs, cash flow, KPIs, covenants, and investor messaging.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Policy Design",
    text: "We build tailored accounting treatments, disclosure structures, and transition plans aligned with your sector and reporting strategy.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Hands-on Conversion",
    text: "We assist with calculations, restatements, documentation, journal entries, and internal control updates across all reporting periods.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Compliance Review",
    text: "We validate disclosures, test interpretations, and prepare audit-ready statements that withstand regulatory and investor scrutiny.",
  },
];
export const oasHeading = {
  subtitle: "OUR ASSURANCE APPROACH",
  title: "A METHODOLOGY BUILT ON EVIDENCE & STAKEHOLDER TRUST",
  description1:
    "Assurance only matters when it reflects how a business actually runs, not just how it’s documented. We study how information moves through systems and people, targeting assurance in the areas where uncertainty can turn costly.",
  description2:
    "We then convert that understanding into structured testing, analytics, and validation that leaves no room for assumption or estimation. You receive findings that are clear, defensible, and built to stand up in board discussions, investor scrutiny, or regulatory review.",
};

export const oasSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Process Intelligence",
    text: "We trace data journeys end-to-end, revealing gaps where information may weaken or lose reliability.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Risk Hotspots",
    text: "We diagnose where controls break, where judgments are subjective, and where misreporting risk is highest.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Evidence Testing",
    text: "We validate numbers, narratives, ESG claims, and operational metrics with data-driven verification.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Insight Reporting",
    text: "We present conclusions in a clear, decision-ready manner designed for boards, regulators, and stakeholders.",
  },
];
export const icfHeading = {
  subtitle: "HOW WE STRENGTHEN",
  title: "A STRUCTURED METHOD THAT IMPROVES AND PROTECTS",
  description1:
    "Strong controls aren’t built overnight; they emerge when risk exposure is understood deeply and operational behavior is studied closely. We observe how work actually flows and identify where controls fail because people override systems or systems don’t capture reality.",
  description2:
    "Our team then reconstructs your control layer with clarity — defining ownership, escalation paths, approval logic, automated checks, and continuous reporting triggers. Next, you get the outcome – the control that lives inside your daily execution and protects decision-makers with certainty. ",
};

export const icfSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Process Discovery",
    text: "We map your actual workflows. This helps us uncover manual touchpoints, authority overlaps, and operational blind spots.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Risk Isolation",
    text: "We break down every critical step to identify where errors originate, where fraud could occur, and where governance collapses under pressure.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Control Engineering",
    text: "A customized control architecture is built using preventive + detective layers, automated checks inside ERP, approval hierarchies, and exception logging.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Performance Monitoring",
    text: "We implement dashboards, test controls cyclically, track exceptions, and recommend process updates as business evolves.",
  },
];
export const dealAdvisoryHeading = {
  subtitle: "HOW WE LOCK DEALS",
  title: "OUR INSIGHTFUL APPROACH FOR POSITIVE OUTCOMES",
  description1:"Deals succeed not just when they close but when they scale. We don’t chase transactions; we evaluate long-term gain, risk exposure, synergy feasibility, and post-deal integration impact. ",
  description2: "Every assumption is challenged, every valuation tested, and every opportunity stress-checked. We look beyond EBITDA multiples — we measure cultural fit, cash friction, operational pressure points, and upside potential. The aim is simple: back the right deal, not just any deal. ",
};

export const dealAdvisorySteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Deal Feasibility Scan",
    text: "We validate the business case upfront — market potential, strategic fit, synergy possibility, and exit prospects before you invest any amount.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Financial & Risk Analytics",
    text: "Valuation isn’t opinion; it's evidence. We break down real value drivers, downside risks, capital needs, red flags and stress-test future scenarios.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Value Creation Mapping",
    text: "Deal success = what happens after closing. We identify post-merger synergies, integration timelines, operational overlaps and revenue unlocks.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Deal Negotiation & Closure",
    text: "We structure terms, pricing logic, and negotiation levers so you close from a position of strength - protected, prepared, and value-oriented.",
  },
];
export const restructuringHeading = {
  subtitle: "WHAT OUR RESTRUCTURING APPROACH SAYS",
  title: "THE STRUCTURED METHOD BEHIND SUCCESSFUL TURNAROUNDS",
  description1:
    "Restructuring is a structured return-to-health journey. We diagnose what’s broken (cash, demand, operations or culture), and build a turnaround blueprint that protects core strength while fixing the weak spine. ",
  description2: "Most failures happen not due to lack of solutions, but due to poor sequencing and unrealistic expectations. We align teams, lenders, and leadership to move as one — controlling damage early, then rebuilding with intention, discipline, and measurable milestones. ",
};

export const restructuringSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Diagnostic Deep-Dive",
    text: "Uncover core issues like negative cash loops, low utilization, pricing gaps, unproductive assets - and build a clean recovery baseline.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Liquidity Preservation Plan",
    text: "Protect runway through rapid working-capital unlock, debt restructuring dialogues, and operating-cost defence levers.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Revival & Value Roadmap",
    text: "Product/market repositioning, sales acceleration, expense restructuring, and asset reallocation to restore profit breathing space.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Stabilize for Scale",
    text: "Governance frameworks, risk controls and performance dashboards to prevent relapse and sustain future growth.",
  },
];
export const dueDiligenceHeading = {
  subtitle: "HOW WE EXECUTE DILIGENCE",
  title: "A STRUCTURED 4-PHASE REVIEW FOR SUCCESSFUL DILIGENCE",
  description1:"For a successful diligence, it is said not to rush but to engineer. We begin with hard-question framing, scope definition, and data access protocols that ensure clarity before analysis begins. ",
  description2: "We then test financial truth, validate operational capacity, review customer and market positioning, and stress-check risks with scenario thinking — giving you a picture unfiltered, unpolished, and investment-ready. ",
};

export const dueDiligenceSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Comprehensive Data Discovery",
    text: "We track revenue drivers, interview key management, validate operational claims, and flag inconsistencies early before they mess up.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Multi-Layer Business Evaluation",
    text: "Financials, compliance, tax structures, legal exposure, operational efficiency - each domain breaks to understand true business health.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Risk Pressure Analysis",
    text: "What happens if revenue drops by 15%? If compliance rules tighten? We simulate commercial, regulatory, and performance-based stress scenarios.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Deal-Readiness Intelligence Report",
    text: "You receive a decision-ready brief highlighting red flags, negotiation leverage, valuation justification & integration challenges.",
  },
];
export const forensicHeading = {
  subtitle: "HOW WE INVESTIGATE",
  title: "A FORENSIC METHODOLOGY BUILT FOR PROOF",
  description1:"Fraud is rarely obvious. We start by analyzing transactional behaviour, vendor patterns, access trails, approvals and payment pathways to detect inconsistencies that traditional reviews often miss. Evidence always leaves footprints & numbers help us trace them. ",
  description2: "Each finding is validated, quantified and documented in a structured investigation file designed to withstand legal questioning. What you receive is proof, clarity, and direction to act. ",
};

export const forensicSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Deep Transaction Mining",
    text: "Data-driven review of ledgers, logs, invoices, contracts & communication trails to establish factual timelines.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Trail Reconstruction",
    text: "Mapping fund flows, approvals, beneficiaries & misconduct patterns with forensic narration.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Evidence Documentation",
    text: "Preparing audit-ready, law-compliant evidence packs with loss quantification & supporting proof sheets.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Resolution & Action Plan",
    text: "Advisory support for recovery, remediation, and prevention of similar fraud structures for a stress-free future.",
  },
];

export const riskAdvisoryHeading = {
  subtitle: "HOW WE STRENGTHEN",
  title: "A PROACTIVE RISK-INTELLIGENCE FRAMEWORK",
  description1:"Assume how risk starts? It begins with a missed signal. Our process looks deeper than policy gaps, tracking behaviour patterns, operational pressure points, compliance exposure, and real-time stress triggers. The goal is not to fear risk, but to understand it. ",
  description2: "How we change the situation? We convert risk indicators into measurable dashboards, implement controls, evaluate crisis response strength and simulate large-impact scenarios. The outcome: faster decisions, controlled impacts and organizations that stay stable even in volatile conditions. ",
};

export const riskAdvisorySteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Risk Assessment Mapping",
    text: "Evaluating internal controls, compliance exposure, process flows & operational stress points end-to-end.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Framework Design",
    text: "Setting up KRIs, response thresholds, escalation models & monitoring architecture.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Control Implementation",
    text: "Reengineering workflows, strengthening approvals, applying checkpoints & risk-based governance.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Monitoring & Review",
    text: "Continuous oversight with periodic audits, scenario testing & responsive improvement cycles.",
  },
];

export const techAdvisoryHeading = {
  subtitle: "HOW WE EXECUTE",
  title: "A PRACTICAL TECHNOLOGY-TO-VALUE DELIVERY MODEL",
  description1:"Digital transformation fails when tech is implemented faster than people can adopt it. Our approach begins by understanding business friction, workflow stress points, and cost wastage. Then we design technology around real needs, not trends! ",
  description2: "Further, we help businesses transition with clarity, govern the change process, quantify performance improvement, and ensure the solution scales as the organization grows without overspending, over-engineering or overcomplicating. ",
};

export const techAdvisorySteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Diagnostic Discovery",
    text: "We uncover friction points, tech debt and process gaps through maturity diagnostics and business-impact analysis.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Solution Blueprinting",
    text: "We align tools, architecture, and data flow with business goals, ensuring every deployment has purpose, scale potential.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Change-Ready Implementation",
    text: "We oversee integration, automate workflows, manage vendors and support user adoption so technology is embraced — not resisted.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Value Measurement",
    text: "We track uptime, productivity lift, automation ROI and cost efficiency, refining systems continuously to ensure technology keeps paying back.",
  },
];

export const valuationsHeading = {
  subtitle: "OUR VALUATION APPROACH",
  title: "A METHODOLOGY THAT MATCHES MARKET REALITY",
  description1:"Valuation cannot rely on assumptions alone — it requires context, benchmarking, and evidence. We begin with deep business diagnostics, earnings sustainability analysis, risk exposure mapping, and market movement tracking to understand where value is created and where it erodes. ",
  description2: "We back every conclusion with transparent models, comparable analysis, scenario testing, and sensitivity checks, ensuring the final value withstands investor questions, audit review and negotiation pressure. ",
};

export const valuationsSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Business Evaluation",
    text: "Analyze revenue stability, margins, growth curves, capital structure & market positioning.",
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Model Application",
    text: "Apply DCF, market comps, income/cost approach — whichever best reflects economic reality.",
  },
  {
    icon: "/assets/icons/review.png",
    title: "Scenario & Sensitivity Review",
    text: "Test value under stress, upside potential, competition risk & uncertainty factors.",
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Valuation Report & Presentation",
    text: "Deliver audit-ready reports along with investor presentation support & negotiation insights.",
  },
];


// TAXATION HEADINGS & STEPS

export const corporateTaxHeading = {
  subtitle: "NAVIGATING TAX COMPLEXITY",
  title: "STRUCTURED EXECUTION WITH ZERO AMBIGUITY",
  description1: "Tax is never one-size-fits-all — regulations evolve, interpretations change, and every decision impacts profit. We start by understanding business structure, risk positioning and sector-specific obligations so our strategy works in real markets, not on paper.",
  description2: "Execution is then broken into actionable layers such as documentation, computation, disclosure controls and future tax positioning. Hence, every return is defensible, data-backed, and audit-ready without a last-minute rush."
};

export const corporateTaxSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Legal Interpretation Review",
    text: "We decode changing regulations and identify tax implications relevant to your business."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Data & Documentation Mapping",
    text: "Accounting data, invoices, deductibles and expenses are evaluated for eligibility & compliance."
  },
  {
    icon: "/assets/icons/review.png",
    title: "Computation & Adjustment Review",
    text: "Final tax calculations conducted with allowance review and risk-based adjustments."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Submission + Audit Ready",
    text: "Filings, representation and audit responses managed end-to-end with confidence."
  }
];

export const mergerAcquisitionHeading = {
  subtitle: "HOW WE SEAL A DEAL",
  title: "COMPLIANT & FORWARD-TESTED M&A TAX PLANNING",
  description1: "Deals move fast, and taxes don’t forgive speed without review. We bring structure to complexity by evaluating scenarios, cash impacts, regulatory exposure and long-term tax consequences before contracts move to signature stage.",
  description2: "Once a deal is active, our team guides execution through documentation reviews, pricing models, integration tax mapping and dispute-proof structuring. This is to ensure your acquisition strengthens performance rather than adding unseen burdens."
};

export const mergerAcquisitionSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Discovery Analysis",
    text: "We map tax history, litigation exposure and legacy obligations to highlight deal sensitivity."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Valuation Alignment",
    text: "Tax impact built into pricing models to avoid overvaluation and shrink post-deal surprises."
  },
  {
    icon: "/assets/icons/review.png",
    title: "Structuring Blueprint",
    text: "Transaction roadmaps covering share/asset purchase formats, capital gain impact & holding logic."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Seamless Integration",
    text: "Post-merger consolidation across books, assets, depreciation schedules and compliance cycles."
  }
];

export const transferPricingHeading = {
  subtitle: "TRANSFER PRICING METHOD",
  title: "METHODOLOGY THAT STANDS REGULATORY TESTING",
  description1: "Transfer Pricing fails fastest when it looks theoretical. We ground every policy in real business behaviour — how you create value, who controls risk, and where profits genuinely belong. That means strategies that read like your business, not a template.",
  description2: "Then we prepare you for challenge, not panic. Benchmark studies, master/local files, inter-company logic - every piece is built to answer questions tax authorities will ask before they ask them, so you negotiate confidently instead of defending reactively."
};

export const transferPricingSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Functions, Assets, Risks Analysis",
    text: "We map how functions, assets and risk actually sit inside your business — forming the factual base for pricing outcomes."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Benchmarks & Statistical Testing",
    text: "Comparable sets backed by economic rationale, industry logic and statistical justification — not copy-paste ranges."
  },
  {
    icon: "/assets/icons/review.png",
    title: "Documentation & Narrative Build",
    text: "OECD-ready Local + Master File that explains why pricing is fair, not just what it is — making audits smoother and faster."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Audit Readiness & Defence",
    text: "When authorities challenge, we respond with facts: statement, negotiation support and litigation-ready evidence."
  }
];

export const valueAddedTaxHeading = {
  subtitle: "OUR VAT METHOD",
  title: "PRACTICAL & PREVENTIVE TAX EXECUTION METHOD",
  description1: "Every business is exposed to VAT risk, usually not by negligence, but by interpretation gaps. Our approach starts by mapping revenue streams, reverse charge triggers, and documentation gaps, ensuring the compliance foundation is strong.",
  description2: "Once controls are set, we guide billing, pricing decisions, import/export models and ongoing filings, keeping you compliant without slowing business. With periodic reviews, reconciliations, and advice on policy changes, VAT becomes predictable — not reactive."
};

export const valueAddedTaxSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Risk Scan",
    text: "We deep-dive into your financial flow, uncovering tax-credit gaps and compliance exposures."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Documentation Build",
    text: "No scattered files. No missing proofs. We standardize invoices and create a clean, trackable transaction trail."
  },
  {
    icon: "/assets/icons/review.png",
    title: "Continuous Compliance",
    text: "Routine filings, reconciliations, input credit tracking, portal updates, regulatory revisions—handled continuously."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Audit-Ready Positioning",
    text: "We provide negotiation support, defend claims with documented proof, and reduce the risk of disputes or penalties."
  }
];

export const internationalTaxHeading = {
  subtitle: "STRATEGY MEETS COMPLIANCE",
  title: "A CLEAR FRAMEWORK THAT SIMPLIFIES GLOBAL TAX",
  description1: "Our methodology blends regulatory understanding with practical commercial insights. We map tax liabilities, identify risks early, and implement structures designed to stand strong against scrutiny.",
  description2: "Each engagement begins with jurisdictional research, applies treaty logic, and concludes with models that enhance net returns while maintaining full compliance."
};

export const internationalTaxSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Jurisdiction Mapping",
    text: "Every market plays by different tax rules. We map them with precision and red-flag regions before you invest a single dollar."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Risk & Compliance Analysis",
    text: "We evaluate BEPS exposure, reporting obligations & anti-avoidance risk, so expansion never surprises you later."
  },
  {
    icon: "/assets/icons/review.png",
    title: "Structural Tax Planning",
    text: "We design entity structures, profit flows, IP ownership models & withholding strategies that reduce leakage."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Reporting & Filing Execution",
    text: "Reporting means proving compliance without friction. From multi-nation filings to foreign income reporting, we’re your partner."
  }
];

export const exciseTaxHeading = {
  subtitle: "HOW WE NAVIGATE EXCISE",
  title: "A STRUCTURED, ZERO-RISK STRATEGY FOR EXCISE TAX",
  description1: "Excise taxation demands precision. Our approach begins by breaking down your product flows, liabilities and internal systems so tax outcomes become predictable, measurable and transparent.",
  description2: "Next, we implement controls, reporting formats and compliance tracking that scale with your operations. You stay audit-ready, penalty-proof and informed at all times — while we handle complexity behind the scenes."
};

export const exciseTaxSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Liability Diagnosis",
    text: "We assess product categories, applicable duties, exemptions and red-flag gaps to quantify potential exposure."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Tax Mapping Blueprints",
    text: "Duty-rate matrices, invoice structure, exemption eligibility and process-level controls built specifically for your business."
  },
  {
    icon: "/assets/icons/review.png",
    title: "Real-Time Compliance Enablement",
    text: "Filing cycles, documentation trails, inventory movement records & reporting — automated, monitored and timely."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Audit & Dispute Management",
    text: "Defending claims, preparing submissions, tracking appeals and closing cases with minimum financial impact."
  }
];

export const taxRestructuringHeading = {
  subtitle: "HOW WE RESTRUCTURE TAX",
  title: "A LAYER-WISE FRAMEWORK FOR TAX EFFICIENCY",
  description1: "Tax restructuring isn't rearranging numbers — it defines how a business earns, spends, and distributes money. We begin by mapping existing tax architecture, identifying structural leakages and assessing operational gaps that silently drain profitability.",
  description2: "Once current exposures are understood, we restructure business units, internal transactions and tax touchpoints for optimal outcomes. Execution is phased, compliant and backed by documentation for a smooth shift with measurable benefits."
};

export const taxRestructuringSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Structural Scan",
    text: "Detailed review of transactions, assets, cross-charges & existing tax layouts to detect inefficiencies."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Blueprint Design & Forecasting",
    text: "Simulation of tax outcomes, entity redesign plans & long-term benefit modelling before implementation."
  },
  {
    icon: "/assets/icons/review.png",
    title: "Implementation & Documentation",
    text: "Execution with corporate filings, documentation packs, statutory updates & stakeholder alignment."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Monitoring & Support",
    text: "Post-restructuring analysis, quarterly review cycles & compliance fine-tuning to preserve benefits."
  }
];

export const economicSubstanceRegulationsHeading = {
  subtitle: "A CLARITY-FIRST METHOD",
  title: "FROM ASSESSMENT TO PROOF – ESR'S STAGES COVERED",
  description1: "ESR compliance isn't about paperwork, it’s about evidence. We begin with a deep review of your operations, profit-generating activities and decision-making trail to identify what the authority must see and what is currently missing.",
  description2: "Once risks are clear, we rebuild substance documentation, align reporting structures, and prepare ESR filings with supporting proof. Our implementation ensures that compliance is sustainable; not just seasonal."
};

export const economicSubstanceRegulationsSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Business Substance Diagnostic",
    text: "Assessment of Core Income-Generating Activities (CIGA), staffing, physical presence & decision-trail documentation."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Substance Enhancement & Setup",
    text: "Policy frameworks, board process structuring & commercial activity alignment for compliance sustainability."
  },
  {
    icon: "/assets/icons/review.png",
    title: "ESR Filing Execution",
    text: "Preparation of ESR notifications & annual returns with ready-to-present supporting documentation packs."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Review Cycles & Monitoring",
    text: "Quarterly checks to ensure continued compliance, policy updates & new-year filing readiness."
  }
];

export const financeAndAccountingHeading = {
  subtitle: "WAY WE MANAGE YOUR FINANCE",
  title: "A 4-STEP OPERATING MODEL THAT KEEPS YOUR BOOKS ACCURATE",
  description1:
    "Our approach replaces scattered financial management with structured, error-proof workflows. We take charge of daily accounting, centralize data, standardize documentation, and maintain real-time visibility.",
  description2:
    "Every business has a unique rhythm of collections, payables, closings, and reporting. Instead of forcing a template, we tailor processes, automate repetitive tasks, assign ownership, and build reporting dashboards that speak clearly."
};

export const financeAndAccountingSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Financial Workflow Setup",
    text: "We define how invoices move, who approves payments, what gets recorded and ensure zero ambiguity in ownership."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Daily Accounting Management",
    text: "Transaction logging, reconciliations, and updating books happens continuously — not once in a month."
  },
  {
    icon: "/assets/icons/review.png",
    title: "Monthly Closing & MIS Reporting",
    text: "We don’t just prepare reports; we highlight patterns, deviations, cash risks, and performance movements."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Compliance & Audit-Ready Records",
    text: "Statements, vouchers, tax trails, and ledgers stay clean, traceable, and audit-friendly."
  }
];
export const corporateAdvisoryServicesHeading = {
  subtitle: "WE DRIVE BETTER DECISIONS",
  title: "OUR STEP-BY-STEP CORPORATE ADVISORY METHODOLOGY",
  description1:
    "Strong advisory starts with clarity. We analyze your financial position, market dynamics, governance structure, and operational challenges to understand the real drivers behind your decision. This allows us to identify risks early and uncover opportunities that may not be visible internally.",
  description2:
    "We then translate this insight into a strategy built on data, feasibility, and measurable outcomes. The goal is - to equip your leadership with a roadmap that is practical, risk-aware, and directly tied to organizational growth."
};

export const corporateAdvisoryServicesSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Diagnostic Analysis",
    text: "We assess financials, performance gaps, market indicators, and strategic priorities to understand your business."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Scenario & Impact Modelling",
    text: "We forecast outcomes of mergers, restructuring, expansion, or capital changes — to help you select the strongest path."
  },
  {
    icon: "/assets/icons/review.png",
    title: "Strategic Blueprint Development",
    text: "We convert insights into a structured action plan covering timelines, resources, financial impacts and risk controls."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Implementation Oversight",
    text: "We guide execution, track progress, and refine strategies as real-time factors shift."
  }
];
export const expensesClaimManagementHeading = {
  subtitle: "HOW WE WORK",
  title: "A PRECISE, POLICY-ALIGNED EXPENSE WORKFLOW",
  description1:
    "Expense claims often get stuck between unclear policies, missing documents, and manual approvals. We simplify the entire cycle by setting clear rules, digitizing submissions, and applying validation layers that eliminate disputes or back-and-forth communication.",
  description2:
    "Once verified, our team ensures fast approvals, correct reimbursements, and structured reporting that gives management a clearer view of organizational spending and future budgeting needs."
};

export const expensesClaimManagementSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Policy Mapping",
    text: "We align your existing policies or help you redesign them to remove ambiguity and improve compliance."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Streamlined Submission Setup",
    text: "We structure workflows and templates so employees submit complete, correct data on the first attempt."
  },
  {
    icon: "/assets/icons/review.png",
    title: "Verification & Approval Layers",
    text: "We implement multi-level checks to ensure compliance, prevent fraud, and maintain full audit trails."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Analytics & Insights",
    text: "Detailed reporting includes spending patterns, frequent claim types, and potential areas for cost control."
  }
];
export const payrollHrServicesHeading = {
  subtitle: "HOW WE WORK",
  title: "A PROCESS BUILT FOR TRANSPARENCY & EMPLOYEE TRUST",
  description1:
    "We use standardized payroll cycles, automated calculations, and secure workflows to ensure complete accuracy and regulatory compliance. Every detail is verified through a structured process that reduces errors and strengthens operational reliability.",
  description2:
    "Our HR management system ensures smooth employee onboarding, document handling, and ongoing support. With clear communication channels, timely updates, and transparent reporting, your workforce experiences a dependable and well-organized HR environment."
};

export const payrollHrServicesSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Automated Payroll Cycles",
    text: "A structured pay cycle where salaries, deductions, allowances, overtime, and benefits are processed through automated validation."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Secure Employee Data Handling",
    text: "All employee documents, contracts, IDs, and HR records are stored in an organized, audit-ready digital system with strict access."
  },
  {
    icon: "/assets/icons/review.png",
    title: "Compliance Monitoring",
    text: "We track payroll laws, WPS rules, labour regulations, and statutory filings in real time to ensure your HR operations remain compliant."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Transparent Reporting Dashboards",
    text: "You receive structured reports — salary summaries, variance reports, overtime insights, and employee cost breakdowns."
  }
];
export const secondmentHeading = {
  subtitle: "HOW WE WORK",
  title: "A SECONDMENT MODEL BUILT FOR EFFICIENCY",
  description1:
    "Our approach focuses on matching the right talent with the right operational environment. We assess your workload, technical requirements, team structure, and deadlines to assign professionals who can adapt quickly and create immediate value.",
  description2:
    "Once deployed, our secondees follow your internal controls, reporting frameworks, and organizational culture to ensure quality, compliance, and transparency throughout the engagement."
};

export const secondmentSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Talent Mapping",
    text: "We analyze your requirements and identify professionals whose skills, experience, and mindset fit your operational needs."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Seamless Deployment",
    text: "Our secondees integrate into your workspace smoothly, adopting your systems and reporting structure from day one."
  },
  {
    icon: "/assets/icons/review.png",
    title: "Performance Oversight",
    text: "We monitor progress, ensure delivery quality, and provide ongoing guidance to maintain consistent output."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Operational Continuity",
    text: "Your processes remain stable and compliant, regardless of workload fluctuations or staffing gaps."
  }
];
export const treasuryServiceHeading = {
  subtitle: "HOW WE WORK",
  title: "A STRUCTURED TREASURY MODEL THAT MINIMIZES RISKS",
  description1:
    "Every organization faces different liquidity pressures — seasonal cycles, industry volatility, compliance expectations, and multi-bank complexity. Our approach begins with mapping your treasury ecosystem to identify cash leakages, control gaps, and exposure blind spots.",
  description2:
    "We then design a treasury operating model backed by strong controls, automated workflows, and clear reporting."
};

export const treasuryServiceSteps = [
  {
    icon: "/assets/icons/planning.png",
    title: "Treasury Health Assessment",
    text: "A deep dive into cash processes, banking structure, controls, and exposure points to identify improvement opportunities."
  },
  {
    icon: "/assets/icons/testing.png",
    title: "Operating Model Design",
    text: "We define governance frameworks, approval structures, signatory controls, and treasury workflows that strengthen oversight."
  },
  {
    icon: "/assets/icons/review.png",
    title: "Implementation & Control Integration",
    text: "Bank mandate updates, system setups, control rollouts, forecasting models, and reporting dashboards built for real-time clarity."
  },
  {
    icon: "/assets/icons/reporting.png",
    title: "Continuous Monitoring & Reporting",
    text: "Weekly/monthly reviews, risk insights, and treasury KPIs that ensure liquidity management aligned with your business goals."
  }
];
// STRATEGIES
export const marketResearchHeading = {
  subtitle: "HOW WE WORK",
  title: "A STRUCTURED RESEARCH PROCESS FOR GROWTH",
  description1: "Markets move fast — technology shifts, customer expectations evolve, and competition intensifies...",
  description2: "We combine qualitative insights, quantitative data, field research, and analytical modelling to build an evidence-backed view of the opportunity."
};

export const marketResearchSteps = [
  { icon: "/assets/icons/planning.png", title: "Insight Discovery & Problem Framing", text: "We ensure the research answers the right business questions." },
  { icon: "/assets/icons/testing.png", title: "Data Collection & Market Intelligence", text: "Surveys, interviews, trend analysis, and competitive mapping are integrated." },
  { icon: "/assets/icons/review.png", title: "Insight Modelling & Strategy Interpretation", text: "We analyze patterns and turn data into meaningful insights." },
  { icon: "/assets/icons/reporting.png", title: "Recommendations & Strategic Roadmap", text: "Actionable direction with market-aligned recommendations for decision-making." }
];

export const businessConsultingHeading = {
  subtitle: "HOW WE DELIVER IMPACT",
  title: "A STRUCTURED METHODOLOGY ROOTED IN INSIGHT & ACTION",
  description1: "Strong consulting outcomes begin with understanding what’s happening beneath the surface. We examine processes, market dynamics, financial health, and team capability to identify the real drivers of performance.",
  description2: "Next, we translate insights into a clear, structured action plan. Every recommendation is prioritized, mapped to business goals, and supported with measurable KPIs to ensure execution stays on track and results stay visible."
};

export const businessConsultingSteps = [
  { 
    icon: "/assets/icons/planning.png", 
    title: "Diagnostic Mapping", 
    text: "Identifying operational blind spots and growth barriers across your organization." 
  },
  { 
    icon: "/assets/icons/testing.png", 
    title: "Insight Modelling", 
    text: "Translating findings into data-backed insights and improvement opportunities." 
  },
  { 
    icon: "/assets/icons/review.png", 
    title: "Implementation Support", 
    text: "Crafting actionable frameworks & guiding execution with clear steps, structure, and accountability." 
  },
  { 
    icon: "/assets/icons/reporting.png", 
    title: "Performance Tracking", 
    text: "Guiding implementation & monitoring impact through measurable KPIs and optimisation cycles." 
  }
];



// CORPORATE SERVICES
export const entitySetupHeading = {
  subtitle: "HOW WE SIMPLIFY YOUR START",
  title: "A STRUCTURED PROCESS FOR FAST ENTITY FORMATION",
  description1: "Every successful entity begins with clarity, not paperwork. That’s why our process starts by analyzing your business model, revenue flows, ownership expectations, and long-term footprint. This helps us pinpoint the right structure, anticipate regulatory friction, and design a formation roadmap that fast-tracks approvals instead of delaying them. ",
  description2: "Once the blueprint is locked, we execute drafting filings, securing regulatory clearances, aligning licensing requirements, and coordinating with authorities on your behalf. "
};
export const entitySetupSteps = [
  { 
    icon: "/assets/icons/planning.png", 
    title: "Strategic Set-Up Mapping", 
    text: "We assess your ownership structure and operational plans to determine the most efficient and compliant incorporation model." 
  },
  { 
    icon: "/assets/icons/testing.png", 
    title: "Documentation & Regulatory Compliance", 
    text: "All legal documents, filings, and government submissions are managed by our experts to ensure smooth, error-free approval." 
  },
  { 
    icon: "/assets/icons/review.png", 
    title: "License & Registration Management", 
    text: "We negotiate timelines, manage approvals, and resolve regulatory queries across free zone and offshore jurisdictions." 
  },
  { 
    icon: "/assets/icons/reporting.png", 
    title: "Post Set-Up Readiness", 
    text: "Once formed, we deliver a fully operational entity along with compliance schedules & governance essentials." 
  }
];


export const outsourcedFinanceRegulatoryComplianceHeading = {
  subtitle: "A SMARTER OPERATING MODEL",
  title: "A METHODICAL FRAMEWORK FOR RISK-FREE FINANCE OPERATIONS",
  description1: "We begin with a diagnostic that maps your financial processes, reporting cycles, compliance obligations, and operational risks. This gives us a clear picture of what’s working, what’s slowing you down, and where automation or restructuring can save your time.",
  description2: "Once aligned, we deploy a dedicated support team, establish a digital workflow, and build your compliance calendar. Every task is tracked, every deadline pre-empted, and every financial deliverable executed with the efficiency of a fully-equipped internal department."
};

export const outsourcedFinanceRegulatoryComplianceSteps = [
  { 
    icon: "/assets/icons/planning.png", 
    title: "Real-Time Financial Management", 
    text: "We map how money moves in your business—who approves what & where delays happen." 
  },
  { 
    icon: "/assets/icons/testing.png", 
    title: "Regulatory Filing & Reporting", 
    text: "Instead of patchwork fixes, we automate routine tasks, strengthen controls, and reduce errors." 
  },
  { 
    icon: "/assets/icons/review.png", 
    title: "Internal Controls & Governance Setup", 
    text: "Your regulatory calendar is fully taken over—every submission and renewal is scheduled, executed & documented." 
  },
  { 
    icon: "/assets/icons/reporting.png", 
    title: "Compliance Monitoring & Risk Alerts", 
    text: "We track every rule change that impacts you, run regular compliance health checks, and alert you early." 
  }
];


export const companySecretarialHeading = {
  subtitle: "HOW WE WORK",
  title: "A GOVERNANCE PROCESS BUILT FOR ACCURACY",
  description1: "Strong governance begins with clarity, and that’s why our process starts with a complete review of your entity’s current compliance position. We identify gaps, outdated records, and upcoming deadlines, giving you a clear picture of where attention is required.",
  description2: "Once the strategy is aligned, we implement a structured governance calendar, automate reminders, prepare compliance-ready documentation, and perform ongoing monitoring. Your entity stays aligned with statutory requirements, with zero administrative stress."
};

export const companySecretarialSteps = [
  { 
    icon: "/assets/icons/planning.png", 
    title: "Entity Compliance Assessment", 
    text: "We review existing registers, filings, meeting minutes, and documents to map compliance gaps and risks." 
  },
  { 
    icon: "/assets/icons/testing.png", 
    title: "Governance Calendar Setup", 
    text: "All annual deadlines, board obligations, and filing requirements are organized into a proactive compliance schedule." 
  },
  { 
    icon: "/assets/icons/review.png", 
    title: "Documentation & Filing Execution", 
    text: "Notices, resolutions, minutes, statutory forms - everything is drafted, updated, and submitted with precision." 
  },
  { 
    icon: "/assets/icons/reporting.png", 
    title: "Ongoing Monitoring & Advisory", 
    text: "We track regulatory changes, maintain updated records, and provide continuous support for governance queries." 
  }
];

